import { render, staticRenderFns } from "./EditProductBarcodes.vue?vue&type=template&id=3e33a592&scoped=true&"
import script from "./EditProductBarcodes.vue?vue&type=script&lang=js&"
export * from "./EditProductBarcodes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e33a592",
  null
  
)

export default component.exports